var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.28 40.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.59,22.75c0-8.13,6.59-14.72,14.72-14.72,3.73,0,7.13,1.4,9.72,3.69-3.03-4.1-7.88-6.76-13.37-6.76-2.51,0-4.87.57-7,1.56-1.01-2.61-3.53-4.48-6.49-4.48-3.84,0-6.97,3.13-6.97,6.97,0,3.13,2.09,5.76,4.94,6.63-.71,1.85-1.12,3.86-1.12,5.96,0,9.19,7.45,16.64,16.64,16.64,1.84,0,3.61-.31,5.27-.87-.53.06-1.07.09-1.62.09-8.13,0-14.72-6.59-14.72-14.72ZM4.6,9.01c0-3.07,2.49-5.56,5.56-5.56,2.42,0,4.46,1.56,5.22,3.72-2.89,1.66-5.23,4.16-6.69,7.18-2.35-.65-4.09-2.78-4.09-5.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.29,31.8c-2.4,0-4.35-1.95-4.35-4.35s1.95-4.34,4.35-4.34,4.35,1.95,4.35,4.34-1.95,4.35-4.35,4.35ZM35.29,24.52c-1.62,0-2.94,1.32-2.94,2.94s1.32,2.94,2.94,2.94,2.94-1.32,2.94-2.94-1.32-2.94-2.94-2.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3a760a25b8b24dfc801bae91ae8456ca.svg";
export { ForwardRef as ReactComponent };